import { getMetrics, createLink, computeCore } from './common';
import _ from 'lodash-es';

export const compute = (...args) => computeCore(core, ...args);

export const sample = () => undefined;

export const getSiblingOption = (instance, meta, path, def = 0) => {
  if (!_.startsWith(path, '[')) {
    path = `.${path}`;
  }

  return (
    (meta && _.get(instance.options, meta.context.parent.path + path, def)) ||
    def
  );
};

export const core = {
  layout: {
    title: {
      left: function({ size, spacing, x }, meta, instance) {
        const position = getSiblingOption(instance, meta, 'position');
        if (_.startsWith(position, 'right')) {
          return 'auto';
        }

        // const center = !!_.startsWith(position,'center');
        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.left');

        return (
          m.cell.width * (spacing / 200 + x) +
          (m.cell.innerWidth * margin) / 100 +
          '%'
        );
      },
      top: function({ size, spacing, y }, meta, instance) {
        const position = getSiblingOption(instance, meta, 'position');
        if (_.endsWith(position, 'bottom')) {
          return 'auto';
        }

        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.top');
        return (
          m.cell.height * (spacing / 200 + y) +
          (m.cell.innerHeight * margin) / 100 +
          '%'
        );
      },
      right: function({ size, spacing, x }, meta, instance) {
        const position = getSiblingOption(instance, meta, 'position');
        if (!_.startsWith(position, 'right')) {
          return 'auto';
        }

        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.right');
        return (
          100 +
          m.cell.width * (spacing / 200 - (x + 1)) +
          (m.cell.innerWidth * margin) / 100 +
          '%'
        );
      },
      bottom: function({ size, spacing, y }, meta, instance) {
        const position = getSiblingOption(instance, meta, 'position');
        if (!_.endsWith(position, 'bottom')) {
          return 'auto';
        }

        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.bottom');
        return (
          100 +
          m.cell.height * (spacing / 200 - (y + 1)) +
          (m.cell.innerHeight * margin) / 100 +
          '%'
        );
      },
    },
    grid: {
      left: function({ size, spacing, x }, meta, instance) {
        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.left');
        return (
          m.cell.width * (spacing / 200 + x) +
          (m.cell.innerWidth * margin) / 100 +
          '%'
        );
      },
      top: function({ size, spacing, y }, meta, instance) {
        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.top');
        return (
          m.cell.height * (spacing / 200 + y) +
          (m.cell.innerHeight * margin) / 100 +
          '%'
        );
      },
      right: function({ size, spacing, x }, meta, instance) {
        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.right');
        return (
          100 +
          m.cell.width * (spacing / 200 - (x + 1)) +
          (m.cell.innerWidth * margin) / 100 +
          '%'
        );
      },
      bottom: function({ size, spacing, y }, meta, instance) {
        const m = getMetrics(size, spacing);
        const margin = getSiblingOption(instance, meta, 'margin.bottom');
        return (
          100 +
          m.cell.height * (spacing / 200 - (y + 1)) +
          (m.cell.innerHeight * margin) / 100 +
          '%'
        );
      },
    },
  },
};

export const getLayoutVars = (size) => {
  const spacing = 15;
  const m = getMetrics(size, spacing);
  return {
    spacing,
    title: {
      textStyle: {
        fontSize: Math.max(m.cell.minSize / 2, 10),
      },
      show: false,
    },
    grid: {
      containLabel: false,
      borderWidth: 1,
      borderColor: '#888',
      backgroundColor: 'rgba(255,255,255,0.05)',
    },
    compute: `function($rechartsVarArgs, vars, optionMeta, instance) {
        return recharts.layout.compute($rechartsVarArgs, vars, optionMeta, instance);
      }`,
  };
};

export const getGrid = (arg, vars, core) => ({
  show: true,
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  containLabel: createLink('layout.grid.containLabel', vars),
  borderWidth: createLink('layout.grid.borderWidth', vars),
  borderColor: createLink('layout.grid.borderColor', vars),
  backgroundColor: createLink('layout.grid.backgroundColor', vars),
  top: createLink({ ...arg, path: 'layout.grid.top' }, vars, core),
  right: createLink({ ...arg, path: 'layout.grid.right' }, vars, core),
  bottom: createLink({ ...arg, path: 'layout.grid.bottom' }, vars, core),
  left: createLink({ ...arg, path: 'layout.grid.left' }, vars, core),
});

export const getTitle = (arg, vars, core) => ({
  show: createLink('layout.title.show', vars),
  position: 'left-top',
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  left: createLink({ ...arg, path: 'layout.title.left' }, vars, core),
  top: createLink({ ...arg, path: 'layout.title.top' }, vars, core),
  right: createLink({ ...arg, path: 'layout.title.right' }, vars, core),
  bottom: createLink({ ...arg, path: 'layout.title.bottom' }, vars, core),
  textStyle: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: createLink('layout.title.textStyle.fontSize', vars),
  },
});
